module.exports = {
    templateUrl: 'validate-business-info/components/validate-business-info-vat-form.html'
}